import { render } from "./CaseInfoPopUp.vue?vue&type=template&id=7563f398&scoped=true&ts=true"
import script from "./CaseInfoPopUp.vue?vue&type=script&lang=ts"
export * from "./CaseInfoPopUp.vue?vue&type=script&lang=ts"

import "./CaseInfoPopUp.vue?vue&type=style&index=0&id=7563f398&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7563f398"]])

export default __exports__